import WithdrawPage from '../../components/pages/accounts/WithdrawPage'
export default {
  components: { WithdrawPage }
}
